import type { ParceiroAutenticado } from '@pgcustom/shared-types';

type OuvintePortalSessao = (parceiro: ParceiroAutenticado | null) => void;

/**
 * Mesmo padrão de `core/session.ts` (`SessionStore`), mas para o
 * contexto do Portal do Parceiro — deliberadamente uma instância
 * separada, nunca compartilhada com `sessionStore` (Auth interno).
 * NUNCA persiste em `localStorage` — a sessão real vive no cookie
 * `httpOnly` `pg_portal_parceiro_session`, controlado pelo backend;
 * este store só espelha o que `GET /portal-parceiros/me` respondeu.
 */
export class PortalParceiroSessionStore {
  private parceiro: ParceiroAutenticado | null = null;
  private readonly ouvintes = new Set<OuvintePortalSessao>();

  obterParceiro(): ParceiroAutenticado | null {
    return this.parceiro;
  }

  estaAutenticado(): boolean {
    return this.parceiro !== null;
  }

  definirParceiro(parceiro: ParceiroAutenticado | null): void {
    this.parceiro = parceiro;
    this.ouvintes.forEach((ouvinte) => ouvinte(parceiro));
  }

  inscrever(ouvinte: OuvintePortalSessao): () => void {
    this.ouvintes.add(ouvinte);
    return () => this.ouvintes.delete(ouvinte);
  }
}

export const portalParceiroSessionStore = new PortalParceiroSessionStore();
